<div class="e-spinner-container">
    <div class="e-squares-container" [ngStyle]="{'height.px': getContainerSize(), 'width.px': getContainerSize()}">
        <div class="e-squares">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</div>
